import { apiBaseUrl } from "api/api";

export type EmailFrequency = 1 | 2 | 3;

export const previewEmailFrequency = async (token: string) => {
  const response = await fetch(
    `${apiBaseUrl}/api/email-frequency/preview?token=${encodeURIComponent(token)}`
  );
  return response.json();
};

export const updateEmailFrequency = async (token: string, frequency: EmailFrequency) => {
  const response = await fetch(`${apiBaseUrl}/api/email-frequency/update`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token, frequency }),
  });
  return response.json();
};

